/* eslint-disable camelcase */
import { setLocalStorage, getLocalStorage } from '@/utils'
import { PlATFORM_CHANNEL, DEFAULT_AREA_LIST, BASE_CATEGORY,BASE_BRAND,BASE_SORT,BASE_PRICE, BASE_PEOPLE,BASE_CHANGE, DEFAULT_AREA_LISTCHILDREN} from '@/utils/constant'
import { resolve } from 'url'
import { reject } from 'q'
import { getGoodsDicts,getBrandsLists } from '@/api/category'
import { get } from 'https'
import { stat } from 'fs'
const base = {
  state: {
    platformChannel: getLocalStorage(PlATFORM_CHANNEL, 'f'),
    defaultAreaList: getLocalStorage(DEFAULT_AREA_LIST, 'true'),
    defaultAreaListChildren: getLocalStorage(DEFAULT_AREA_LISTCHILDREN, 'true'),
    categorys : getLocalStorage(BASE_CATEGORY,"f"),
    brands: getLocalStorage(BASE_BRAND, 'f'),
    sorts : getLocalStorage(BASE_SORT,'f'),
    prices : getLocalStorage(BASE_PRICE,'f'),
    peoples : getLocalStorage(BASE_PEOPLE,'f'),
    changes : getLocalStorage(BASE_CHANGE,'f')
  },
  mutations: {
    SET_PlATFORM_CHANNEL: (state, id) => {
      state.platformChannel = id
      setLocalStorage(PlATFORM_CHANNEL, id)
    },
    SET_DEFAULT_AREA_LIST: (state, data) => {
      state.defaultAreaList = data
      setLocalStorage(DEFAULT_AREA_LIST, data)
    },
    SET_DEFAULT_AREA_LISTCHILDREN: (state, data) => {
      state.defaultAreaList = data
      setLocalStorage(DEFAULT_AREA_LISTCHILDREN, data)
    },
    SET_BASE_CATEGORY : (state, data) => {
      state.categorys = data
      setLocalStorage(BASE_CATEGORY, data)
    },
    SET_BASE_BRAND : (state,data) =>{
      state.brands = data
      setLocalStorage(BASE_BRAND,data)
    },
    SET_BASE_SORT : (state,data) => {
      state.sorts = data
      setLocalStorage(BASE_SORT,data)
    },
    SET_BASE_PRICE : (state,data) => {
      state.prices = data
      setLocalStorage(BASE_PRICE,data)
    },
    SET_BASE_PEOPLE : (state,data) => {
      state.peoples = data
      setLocalStorage(BASE_PEOPLE,data)
    },
    SET_BASE_CHANGE : (state,data) => {
      state.changes = data
      setLocalStorage(BASE_CHANGE,data)
    }
  },
  actions: {
    setPlatformChannel ({ commit }, data) {
      return new Promise(resolve => {
        commit('SET_PlATFORM_CHANNEL', data)
        resolve()
      }).catch(error => {
        console.log(error)
      })
    },
    //获取成色，类别，筛选的数据
    getBaseData({commit}){
      return new Promise((resolve,reject)=>{
        getGoodsDicts().then(response=>{
          let result = response
          commit('SET_BASE_CATEGORY', result.categoryFilterItemResponseList)
          commit('SET_BASE_SORT',result.sortingTypeFilterItemResponseList)
          commit('SET_BASE_PRICE',result.priceRangeFilterItemResponseList)
          commit('SET_BASE_PEOPLE',result.intendedPopulationFilterItemResponseList)
          commit('SET_BASE_CHANGE',result.colorfilterItemResponseList)
          resolve()
        }).catch(error => {
          console.log(error)
          reject(error)
        })
      })
    },
    //获取品牌的数据
    getBrandList({commit},brandId) {
      return new Promise((resolve,reject)=>{
        getBrandsLists(brandId).then(response=>{
          commit('SET_BASE_BRAND',response)
        }).catch(error=>{
          console.log(error)
          reject(error)
        })
      })
    }
  }
}
export default base

